import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { IoSunny, IoMoon } from 'react-icons/io5';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative w-10 h-10 rounded-xl border border-dexora-cyan/30 flex items-center justify-center transition-all hover:border-dexora-cyan/50 hover:bg-dexora-cyan/10 ${className}`}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === 'dark' ? (
        <IoSunny className="w-5 h-5 text-dexora-cyan" />
      ) : (
        <IoMoon className="w-5 h-5 text-dexora-cyan" />
      )}
    </button>
  );
};

export default ThemeToggle;
